module.exports = __webpack_public_path__ + "img/pet_saying_hello.da6c5e11.svg";